import BlankEtc from '@components/blank/BlankEtc';
import Header from '@components/Header';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import CloseLineIcon from '@icons/CloseLineIcon';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import NotificationItem from './components/NotificationItem';
import NotificationTitle from './components/NotificationTitle';
import useNotifications from './hooks/useNotifications';

const NotificationActivity: ActivityComponentType = () => {
    const { t } = useTranslation('notification');
    const {
        notifications, fetchNextPage, isBlank, isFetching,
    } = useNotifications();
    return (
        <AppScreen>
            <Header title=''
                backIcon={CloseLineIcon}
                noShadow />
            <NotificationTitle isBlank={isBlank}/>
            {notifications?.map((notification, index) => (
                <NotificationItem notification={notification}
                    key={notification.notificationId} />
            ))}
            <InfinityScrollTrigger trigger={fetchNextPage} />
            {isFetching && (
                <Loading size='small'/>
            )}
            {isBlank && (
                <BlankEtc>
                    {t('empty')}
                </BlankEtc>
            )}

        </AppScreen>
    );
};

export default NotificationActivity;
